<template>
  <div class="footer">
    <span class="left">
      Copyright:©2016-{{ year }}&nbsp;大连拓中教育科技股份有限公司&nbsp;
      <!-- <a v-if="$siteName === 'fib'" :href="`/frontend/document/release-${$siteName}.txt`" target="_blank" class="release">最近更新</a>
      <a v-if="$siteName === 'training'" :href="`/document/release-${$siteName}.txt`" target="_blank" class="release">最近更新</a> -->
    </span>
    <span class="right">{{ now }}</span>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: 'JmFooter',
  computed: {
    now() {
      return moment().format('YYYY年MM月DD日 HH:mm:ss');
    },
    year() {
      return moment().format('YYYY');
    }
  }
};
</script>
<style>
.footer {
  width: 100%;
  height: 20px;
  line-height: 20px;
  padding: 0 15px;
  background-color: #01142d;
  overflow: hidden;
  position: fixed;
  z-index:10000;
  bottom: 0;
  left: 0;
}

.footer .left {
  width: 50%;
  float: left;
  color: #fff;
  font-size: 12px;
}

.footer .right {
  width: 50%;
  float: right;
  color: #fff;
  font-size: 12px;
  text-align: right;
}

.footer .release {
  color:yellow
}
</style>
